import React, { useEffect, useState } from 'react'
import {
  useTranslate,
  useNotify,
  BooleanInput,
} from 'react-admin'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { Grid, Skeleton} from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'

export const FormBilling = ({ record }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [basesList, setBasesList] = useState([])
  const [loadingBasesList, setLoadingBasesList] = useState(false)
  useEffect(() => {
    getBases()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getBases = async () => {
    setLoadingBasesList(true)
    try {
      const allBases = await reservationServices.getAllAlternativeBases()
      if (allBases) {
        setBasesList(allBases.map((elem) => ({ name: elem })))
        setLoadingBasesList(false)
        return
      }
      notify(`bases not found`, { type: 'error' })
      setLoadingBasesList(false)
    } catch (error) {
      notify(`please, refresh page`, { type: 'error' })
      setLoadingBasesList(false)
    }
  }

  return (
    <>
      <Grid container spacing={3}>
        <EditInputsWrap label={translate('ra.field.billing_default_base')}>
          {loadingBasesList ? (
            <Skeleton variant='rectangular' width={'100%'} height={40} />
          ) : (
            <SelectInput
              size='small'
              optionsText={['name']}
              optionValue='name'
              fullWidth
              label={false}
              source='billing_default_base'
              options={basesList}
              defaultValue={record?.billing_default_base || ''}
              showSearch
            />
          )}
        </EditInputsWrap>
        <EditInputsWrap label={translate('ra.field.billing_alternate_base')}>
          {loadingBasesList ? (
            <Skeleton variant='rectangular' width={'100%'} height={40} />
          ) : (
            <SelectInput
              size='small'
              optionsText={['name']}
              optionValue='name'
              fullWidth
              label={false}
              source='billing_alternate_base.options'
              options={basesList}
              defaultValue={record?.billing_alternate_base?.options || []}
              showSearch
              multiple
            />
          )}
        </EditInputsWrap>
        <EditInputsWrap label={translate('ra.field.auto_billable')}>
          <BooleanInput
            label={translate('ra.field.auto_billable')}
            source='auto_billable'
            fullWidth
            defaultValue={true}
          />
        </EditInputsWrap>
      </Grid>
    </>
  )
}
